/**
 * In-memory auth state. IN MEMORY ONLY — never localStorage, sessionStorage, a cookie, a URL, or a
 * log. Nothing here decodes the token: identity comes from GET /api/me.
 */
const state: { accessToken: string | null; csrfToken: string | null } = {
  accessToken: null,
  csrfToken: null,
};
let sessionExpiredHandler: (() => void) | null = null;

export function getAccessToken(): string | null {
  return state.accessToken;
}

export function setAccessToken(token: string | null): void {
  state.accessToken = token;
}

export function getCsrfToken(): string | null {
  return state.csrfToken;
}

export function setCsrfToken(token: string | null): void {
  state.csrfToken = token;
}

export function clearAuth(): void {
  state.accessToken = null;
  state.csrfToken = null;
}

export function setSessionExpiredHandler(handler: (() => void) | null): void {
  sessionExpiredHandler = handler;
}

/** The factory's onSessionExpired: a silent refresh failed. Clear state, then let the app leave. */
export function notifySessionExpired(): void {
  clearAuth();
  sessionExpiredHandler?.();
}

/** Test seam. */
export function __resetAuthStore(): void {
  clearAuth();
  sessionExpiredHandler = null;
}
